/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListConversationsQueryResponse, ListConversationsPathParams, ListConversationsQueryParams, ListConversations401, ListConversations500 } from "../../types/chatController/ListConversations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListConversationsUrl(organizationId: ListConversationsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/chat/conversations` as const }
  return res
}

/**
 * @summary List AI chat conversations
 * {@link /api/organizations/:organizationId/chat/conversations}
 */
export async function listConversations(organizationId: ListConversationsPathParams["organizationId"], params?: ListConversationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListConversationsQueryResponse, ResponseErrorConfig<ListConversations401 | ListConversations500>, unknown>({ method : "GET", url : getListConversationsUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}